import React, { useState } from 'react';
import './BenefitsSection2.css';
import { UserPlus, Database, LogIn, MapPin, CheckCircle, Target, Clock, BarChart, Layers, Shield, Award } from 'lucide-react';
import { Link, useNavigate } from 'react-router-dom';

const BenefitsSection = (props) => {
  // const { activeTab, setActiveTab } = props;
  const [activeTab, setActiveTab] = useState('agents');
  const navigate = useNavigate();
  const [showDemoForm, setShowDemoForm] = useState(false);
  const [demoData, setDemoData] = useState({
    name: '',
    email: '',
    company: '',
    message: ''
  });

  const handleChange = (e) => {
    setDemoData({ ...demoData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const { name, email, company, message } = demoData;
    const subject = encodeURIComponent('Demo Request');
    const body = encodeURIComponent(
      `Name: ${name}\nEmail: ${email}\nCompany: ${company}\n\nMessage:\n${message}`
    );
    window.location.href = `mailto:harry@amenityscores.com?subject=${subject}&body=${body}`;
  };

  return (
    <section className="benefits-section">
      <div className="benefits-container">
        {/* <div className="tab-switcher">
          <button
            className={`tab-button ${activeTab === 'buyers' ? 'active' : ''}`}
            onClick={() => setActiveTab('buyers')}
          >
            For Buyers
          </button>
          <button
            className={`tab-button ${activeTab === 'agents' ? 'active' : ''}`}
            onClick={() => setActiveTab('agents')}
          >
            For Agents
          </button>
        </div> */}

        {/* Section Header - Above card container */}
        <div className="section-header">
          <h2 className="section-title">
            {activeTab === 'buyers' 
              ? "Find Your Perfect Neighborhood" 
              : "Empower Your Real Estate Business"}
          </h2>
          <p className="section-description">
            {activeTab === 'buyers' 
              ? "We help you understand if a neighborhood meets your needs with comprehensive amenity scoring."
              : "Amenity Scores provides estate agents with powerful tools to attract quality buyers and close deals faster."}
          </p>
        </div>

        {
        activeTab === 'buyers' ? (
          <div className="benefits-card-container">
            <div className="benefits-text">
              {/* <h2 className="section-title">Find Your Perfect Neighborhood</h2>
              <p className="section-description">
                We help you understand if a neighborhood meets your needs with comprehensive amenity scoring.
              </p> */}

              <div className="score-card">
                <div className="score-header">
                  <h3>Neighborhood Score</h3>
                  <div className="overall-score">95/100</div>
                </div>

                <div className="score-categories">
                  <div className="category">
                    <div className="category-header">
                      <span>Education</span>
                      <span>9/10</span>
                    </div>
                    <div className="progress-bar">
                      <div className="progress-fill education" style={{ width: '90%' }}></div>
                    </div>
                  </div>

                  <div className="category">
                    <div className="category-header">
                      <span>Transport</span>
                      <span>8.5/10</span>
                    </div>
                    <div className="progress-bar">
                      <div className="progress-fill transport" style={{ width: '85%' }}></div>
                    </div>
                  </div>

                  <div className="category">
                    <div className="category-header">
                      <span>Parks & Recreation</span>
                      <span>8/10</span>
                    </div>
                    <div className="progress-bar">
                      <div className="progress-fill parks" style={{ width: '80%' }}></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="benefits-cards">
              <div className="card">
                <div className="card-icon">
                  <Layers size={24} />
                </div>
                <h3>Comprehensive Insights</h3>
                <p>Detailed breakdown of neighborhood amenities based on proximity, quality and quantity.</p>
              </div>

              <div className="card">
                <div className="card-icon">
                  <MapPin size={24} />
                </div>
                <h3>London Coverage</h3>
                <p>Detailed analysis for every London street and postcode.</p>
              </div>

              <div className="card">
                <div className="card-icon">
                  <Shield size={24} />
                </div>
                <h3>Trusted Data</h3>
                <p>Accurate information from official and reputable sources.</p>
              </div>

              <div className="card">
                <div className="card-icon">
                  <Clock size={24} />
                </div>
                <h3>Time Saving</h3>
                <p>Quickly evaluate multiple neighborhoods without endless research.</p>
              </div>
            </div>
          </div>
        ) : (
          <div className="benefits-card-container">
            <div className="agents-text">
              {/* <h2 className="section-title">Empower Your Real Estate Business</h2>
              <p className="section-description">
                Property Amenities Rating Ltd provides estate agents with powerful tools to attract quality buyers and close deals faster.
              </p> */}

              <div className="benefits-list">
                <div className="benefit-item">
                  <div className="benefit-icon">
                    <Award size={24} />
                  </div>
                  <div>
                    <h3>Improve local knowledge</h3>
                    {/* <p>Eliminate time-wasters with qualified leads who know what they want.</p> */}
                  </div>
                </div>

                <div className="benefit-item">
                  <div className="benefit-icon">
                    <BarChart size={24} />
                  </div>
                  <div>
                    <h3>More accurate valuations</h3>
                    {/* <p>Stand out with unique data insights other agents don't provide.</p> */}
                  </div>
                </div>

                <div className="benefit-item">
                  <div className="benefit-icon">
                    <Target size={24} />
                  </div>
                  <div>
                    <h3>Win more instructions</h3>
                    {/* <p>Higher viewing-to-offer ratios with informed buyers.</p> */}
                  </div>
                </div>

                <div className="benefit-item">
                  <div className="benefit-icon">
                    <Clock size={24} />
                  </div>
                  <div>
                    <h3>Generate more high-quality enquiries</h3>
                    {/* <p>Properties sell faster when buyers have all the information they need.</p> */}
                  </div>
                </div>

                <div className="benefit-item">
                  <div className="benefit-icon">
                    <Clock size={24} />
                  </div>
                  <div>
                    <h3>Justify the asking price</h3>
                    {/* <p>Properties sell faster when buyers have all the information they need.</p> */}
                  </div>
                </div>

                <div className="benefit-item">
                  <div className="benefit-icon">
                    <Clock size={24} />
                  </div>
                  <div>
                    <h3>Sell properties faster</h3>
                    {/* <p>Properties sell faster when buyers have all the information they need.</p> */}
                  </div>
                </div>
              </div>
            </div>



            <div className="signup-details">
              <h3 className="section-title">Get Started in 3 Easy Steps</h3>
              <div className="signup-steps">
                <div className="step">
                  <div className="step-icon">
                    <UserPlus size={24} />
                  </div>
                  <div className="step-content">
                    <h3>Signup/Login</h3>
                    <p>Signup/Login for an account on our website to peruse street scores.</p>
                  </div>
                </div>
                
                <div className="step">
                  <div className="step-icon">
                    <LogIn size={24} />
                  </div>
                  <div className="step-content">
                    <h3>Request Scores</h3>
                    <p>Request Scores for your Listings</p>
                  </div>
                </div>
                
                <div className="step">
                  <div className="step-icon">
                    <Database size={24} />
                  </div>
                  <div className="step-content">
                    <h3>Receive Scores</h3>
                    <p>Receive Scores via API to include on your website and other sales material.</p>
                  </div>
                </div>

                <div className="cta-buttons">
                  <button
                    className="cta-button primary"
                    onClick={() => navigate('/signup')}
                  >
                    Signup / Login
                  </button>
                  <button
                    className="cta-button secondary"
                    onClick={() => setShowDemoForm(prev => !prev)}
                  >
                    Request Demo
                  </button>
                </div>

                {showDemoForm && (
                  <form className="demo-form" onSubmit={handleSubmit}>
                    <input
                      type="text"
                      name="name"
                      placeholder="Your Name"
                      value={demoData.name}
                      onChange={handleChange}
                      required
                    />
                    <input
                      type="email"
                      name="email"
                      placeholder="Your Email"
                      value={demoData.email}
                      onChange={handleChange}
                      required
                    />
                    <input
                      type="text"
                      name="company"
                      placeholder="Company"
                      value={demoData.company}
                      onChange={handleChange}
                    />
                    <textarea
                      name="message"
                      placeholder="Your Message"
                      value={demoData.message}
                      onChange={handleChange}
                      rows={4}
                    />
                    <button type="submit" className="submit-demo">
                      Send Request
                    </button>
                  </form>
                )}
              </div>
            </div>
          </div>
        )
        }
      </div>
    </section>
  );
};

export default BenefitsSection;